import { Typography, useTheme } from "@mui/material";

interface Props {
  title: string;
  description: string;
}

const SubTitle = ({ title, description }: Props) => {
  const theme: any = useTheme();
  const styles = {
    title: {
      color: theme.palette.grey[0],
      mb: theme.spacing(1),
      mt: theme.spacing(8.5),
      lineHeight: "32px",
    },
    description: {
      color: theme.palette.grey[600],
      lineHeight: "16px",
      textTransform: "lowercase",
    },
  };

  return (
    <>
      <Typography variant="h4" sx={styles.title}>
        {title}
      </Typography>
      <Typography variant="overline" sx={styles.description}>
        {description}
      </Typography>
    </>
  );
};

export default SubTitle;
